import { Breadcrumb } from "antd";
import React, { JSX } from "react";
import SearchBarWidget from "./SearchBarWidget";


const Headline = (
  props: {
    bannerImage: string;
    mobileBannerImage?: string;
    showSearch?: boolean;
    title?: string;
    children?: JSX.Element;
    breadcrumbs: any[];
  }
) => {
  const { bannerImage, mobileBannerImage, title, children, breadcrumbs } = props;
  const mobileBannerFallback = mobileBannerImage || bannerImage;

  return (
    <>
      {(props.showSearch == undefined || props.showSearch && props.showSearch == true) && <SearchBarWidget/>}
      <div className="headline">
        <div className="headline_banner" 
          style={{
            '--desktop-banner': 'url(' + bannerImage + ')',
            '--mobile-banner': 'url(' + mobileBannerFallback + ')'
          } as React.CSSProperties}
        ></div>
        <div className="headline_header"> 
          { title ? <h1> {title} </h1> : children}
          <Breadcrumb items={breadcrumbs} separator=">"/>
        </div>
      </div>
    </>
  )
}

export default Headline;